import { FC, Fragment } from 'react';
import {
  RefreshButton,
  ResetButton,
  Searchbox,
  SelectButton,
  Toolbar,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { permissionOptions } from './shared/constants';
import {
  AdvancedSearch,
  PermissionDeleteDialog as DeleteDialog,
  PermissionFormDialog as CreateDialog,
  PermissionTable2,
} from './components';
import { usePermission2 } from './hooks';

const Permission2: FC = () => {
  const {
    canAdd,
    canDelete,
    canEdit,
    data,
    handleAdvancedSearchChange,
    handleCreateAction,
    handleCreateCancel,
    handleCreateRequest,
    handleDeleteAction,
    handleDeleteCancel,
    handleDeleteRequest,
    handlePageChange,
    handleRefresh,
    handleSearchChange,
    handleSearchClear,
    handleSearchEnter,
    handleSearchReset,
    handleStepChange,
    isCreateDialogOpen,
    isDeleteDialogOpen,
    isDeleting,
    isFetched,
    isFetching,
    isFilter,
    isLoading,
    isProcessing,
    isSearch,
    isSearching,
    paginationOffset: currentOffset,
    paginationStep: pageStep,
    params,
    searchQuery,
    selectedItem,
    selectedType,
    wasSearch,
  } = usePermission2();
  const showAddButton = canAdd;

  return (
    <Fragment>
      <Toolbar>
        <Toolbar.Control>
          <Toolbar.Search>
            <Searchbox
              autoFocus
              name="name"
              onChange={handleSearchChange}
              onClear={handleSearchClear}
              onEnter={handleSearchEnter}
              placeholder="Search by name"
              value={searchQuery}
            />
            <AdvancedSearch
              onApply={handleAdvancedSearchChange}
              query={params}
            />
            <ResetButton
              disabled={!isSearch && !isFilter}
              onClick={handleSearchReset}
            >
              Reset Search
            </ResetButton>
            <RefreshButton onClick={handleRefresh}>Refresh</RefreshButton>
          </Toolbar.Search>
          <Toolbar.Action>
            {showAddButton && (
              <Toolbar.Flexbox>
                <SelectButton
                  action="add"
                  label={{
                    button: 'add permission button',
                    option: 'select permission type',
                  }}
                  onClick={handleCreateRequest}
                  options={permissionOptions}
                  title={{
                    click: 'Add permission',
                    toggle: 'Select permission type',
                  }}
                />
              </Toolbar.Flexbox>
            )}
          </Toolbar.Action>
        </Toolbar.Control>
      </Toolbar>
      <PermissionTable2
        canDelete={canDelete}
        canEdit={canEdit}
        data={data.items}
        isFetched={isFetched}
        isFetching={isFetching}
        isFilter={isFilter}
        isLoading={isLoading}
        isProcessing={isProcessing}
        isSearch={isSearch || isFilter}
        isSearching={isSearching}
        onDelete={handleDeleteRequest}
        onPageChange={handlePageChange}
        onStepChange={handleStepChange}
        paginationOffset={currentOffset}
        paginationStep={pageStep}
        totalCount={undefined}
        totalRecord={data.totalRecord}
        wasSearch={wasSearch}
      />
      <CreateDialog
        onClose={handleCreateCancel}
        onSave={handleCreateAction}
        open={isCreateDialogOpen}
        type={selectedType}
      />
      <DeleteDialog
        loading={isDeleting}
        name={selectedItem?.name}
        onClose={handleDeleteCancel}
        onSubmit={handleDeleteAction}
        open={isDeleteDialogOpen}
      />
    </Fragment>
  );
};

export { Permission2 };
